<template>
  <v-app>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

import liff from "@line/liff";

let isVConsole = process.env.VUE_APP_VCONSOLE;
let isLocal = process.env.VUE_APP_LOCAL;

if (isVConsole == '1') {
    let vConsoleScript = document.createElement('script');
    vConsoleScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/vConsole/3.4.0/vconsole.min.js');
    document.head.appendChild(vConsoleScript);

    vConsoleScript.onload = function () {
        var vConsole = new VConsole();
    };
}


export default {
  name: 'App',

  components: {
    // HelloWorld,
  },

  data: () => ({
    // userId: null
  }),
  mounted () {
    let params = new URLSearchParams(window.location.search.substring(1));
    let liffId = params.get("liffId");
    let liffState = params.get("liff.state");
    console.log(liffState);
    if (liffState != undefined) {
      // first login only once
      // alert('first init')
      let sp = new URLSearchParams(liffState.split("?")[1]);
      liffId = sp.get("liffId");
      
    } else {
      // alert('second init')
      console.log(params);
    }

    const initLiff = async () => {
      try {
        console.log(liffId)
        await liff.init({ liffId: liffId });
        if (!liff.isLoggedIn()){
          liff.login({ redirectUri: window.location.href });
        }
        const context = liff.getContext();
        // this.userId = context.userId;
        this.$store.commit('setUserId', context.userId);
        console.log(this.$store.state.userId);

        const accessToken = liff.getAccessToken();
        this.$store.commit("setAccessToken", accessToken);
        console.log("in app: ", accessToken);

        const profile = await liff.getProfile();
        this.$store.commit('setDisplayName', profile.displayName);
        this.$store.commit('setPictureUrl', profile.pictureUrl);

        console.log(this.$store.state.displayName);
        console.log(this.$store.state.pictureUrl);

        
      } catch (err) {
        console.log(`liff.state init error ${err}`);
        if (isLocal) {
          this.$store.commit("setUserId", "U5687c7bd7549dc662d9d3d63f11ac5cd");
          this.$store.commit("setAccessToken", "eyJhbGciOiJIUzI1NiJ9.ZtTddxOd-JISR6DTGbo6Ggth1MqFjwafoSsfx2naediQlauxVhML1wQx1AvhEYeyZETNEb1RGR7seGQNzMLX85tiAffg8Tvk484weB07yhfBqHbtLeawMgUNkKMEDOyMjHytguQsb7T1SDFHOSpRG8nlz-ac0sVNucWMH97mClM.nVCnRQHoHHFwd7ZSnm8eYKgOSo8yP53EEZ1oabp9Pzc")
        }
      }
    }

    initLiff();
  },
};
</script>

<style>
@import url(https://fonts.googleapis.com/earlyaccess/cwtexyen.css);

body {
  font-family: ‘cwTeXYen’, sans-serif;
  font-weight: 300;
}

.fixed-button {
  position: fixed;
  bottom: 2%
}
</style>
